import { render } from "./CustomDropdown.vue?vue&type=template&id=5d0a41c1&scoped=true"
import script from "./CustomDropdown.vue?vue&type=script&lang=js"
export * from "./CustomDropdown.vue?vue&type=script&lang=js"

import "./CustomDropdown.vue?vue&type=style&index=0&id=5d0a41c1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0a41c1"]])

export default __exports__